var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { css, mq, styled } from "../../../utils";
var TableHead = styled.table(function (_a) {
    var markdown = _a.theme.components.markdown;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    th,\n    tr,\n    td {\n      ", ";\n    }\n\n    td {\n      font-weight: normal;\n    }\n  "], ["\n    th,\n    tr,\n    td {\n      ",
        ";\n    }\n\n    td {\n      font-weight: normal;\n    }\n  "])), mq({
        ...markdown.text,
        ...markdown.table,
    }));
});
var TableHeadRenderer = function (props) { return React.createElement(TableHead, __assign({}, props)); };
export default TableHeadRenderer;
var templateObject_1;
//# sourceMappingURL=TableRenderer.js.map